export default [function () {
    return {
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/checkout/services/checkout.service.js